
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_CHANGE = 'AUTH_CHANGE';
export const DATA_CHANGE = 'DATA_CHANGE';
